import { BaseApi } from "../../utils/BaseApi";
import {
  AISettings,
  AllConfigDataModel,
  ProductSyncResult,
  WSSettings,
} from "../models/Config/ConfigModel";
import { HttpMethodEnum } from "../models/HttpMethodEnum";

class ConfigApi extends BaseApi {
  private static instance: ConfigApi;

  public static get(): ConfigApi {
    if (!this.instance) {
      this.instance = new ConfigApi();
    }
    return this.instance;
  }

  public allConfigInfo = BaseApi.createEndpoint<AllConfigDataModel, null>(
    HttpMethodEnum.GET,
    "/config/info"
  );

  public updateConfigInfo = BaseApi.createEndpoint<
    AllConfigDataModel,
    { settings: AISettings | WSSettings }
  >(HttpMethodEnum.PUT, "/config/info");

  public syncProducts = BaseApi.createEndpoint<ProductSyncResult, null>(
    HttpMethodEnum.GET,
    "/config/sync/products"
  );

  public getBanchatConfig = BaseApi.createEndpoint<BanchatConfigStatus, null>(
    HttpMethodEnum.GET,
    "/config/banchat"
  );

  public saveBanchatConfig = BaseApi.createEndpoint<
    { configured: boolean },
    BanchatConfigInput
  >(HttpMethodEnum.PUT, "/config/banchat");

  public deleteBanchatConfig = BaseApi.createEndpoint<
    { configured: boolean },
    null
  >(HttpMethodEnum.DELETE, "/config/banchat");
}

export type BanchatConfigInput = {
  environment: "production" | "sandbox";
  apiKey?: string;
  inboundSecret?: string;
  outboundSecret?: string;
  termsUrl?: string;
  brandName?: string;
  banchatApiV1014Enabled: boolean;
};

export type BanchatConfigStatus = Omit<
  BanchatConfigInput,
  "apiKey" | "inboundSecret" | "outboundSecret"
> & {
  tenantCode: string;
  configured: boolean;
  environment: "production" | "sandbox";
  baseUrl: string;
  documentAllowedHosts: string[];
  notificationsEnabled: boolean;
  apiKeyConfigured: boolean;
  inboundSecretConfigured: boolean;
  outboundSecretConfigured: boolean;
};

export const configApi = ConfigApi.get();
